import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { Statistics } from '@/models/statistics.model';
import statisticsService from '@/services/statistics.service';

import { onMounted, ref } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'UserCharts',
  setup(__props) {

const data = ref<Statistics[]>([]);
const data2 = ref<Statistics[]>([]);
const data3 = ref<Statistics[]>([]);

onMounted(async () => {
  const d = await statisticsService.usersPerDay();
  data.value = d;
  const d2 = await statisticsService.userInterests();
  data2.value = d2;
  const d3 = await statisticsService.userMotivation();
  data3.value = d3;
});

return (_ctx: any,_cache: any) => {
  const _component_v_frappe_chart = _resolveComponent("v-frappe-chart")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, null, {
    default: _withCtx(() => [
      _cache[0] || (_cache[0] = _createElementVNode("h2", null, "User signups per day", -1)),
      _cache[1] || (_cache[1] = _createElementVNode("p", null, "This shows the amount of new users each day for the last 30 days", -1)),
      _createVNode(_component_v_frappe_chart, {
        type: "line",
        labels: data.value.map((d) => d.label),
        data: [
        {
          name: data.value[0]?.stackedValues[0].label || '',
          values: data.value.map((d) => d.stackedValues[0].value),
        },
      ],
        height: 300,
        colors: ['orange']
      }, null, 8, ["labels", "data"]),
      _cache[2] || (_cache[2] = _createElementVNode("h2", null, "User interests", -1)),
      _cache[3] || (_cache[3] = _createElementVNode("p", null, "This shows the amount of new users interested in each main category", -1)),
      _createVNode(_component_v_frappe_chart, {
        type: "bar",
        labels: data2.value.map((d) => d.label),
        data: [
        {
          name: data2.value[0]?.stackedValues[0].label || '',
          values: data2.value.map((d) => d.stackedValues[0].value),
        },
      ],
        height: 300,
        colors: ['orange']
      }, null, 8, ["labels", "data"]),
      _cache[4] || (_cache[4] = _createElementVNode("h2", null, "User Motivation", -1)),
      _cache[5] || (_cache[5] = _createElementVNode("p", null, "This shows the amount of users per type of motivation", -1)),
      _createVNode(_component_v_frappe_chart, {
        type: "bar",
        labels: data3.value.map((d) => d.label),
        data: [
        {
          name: data3.value[0]?.stackedValues[0].label || '',
          values: data3.value.map((d) => d.stackedValues[0].value),
        },
      ],
        height: 300,
        colors: ['orange']
      }, null, 8, ["labels", "data"])
    ]),
    _: 1
  }))
}
}

})